'use client';

import { c as _c } from "react/compiler-runtime";
import { Locale } from 'next-intl';
import { useParams, useSearchParams } from 'next/navigation';
import { PropsWithChildren, createContext, startTransition, useCallback, useContext, useState } from 'react';
import { useRouteChangeContext } from '@/context/RouteChangeContext';
import { usePathname, useRouter } from '@/i18n/navigation';
import { setUserLocale } from '@/server/services/locales';
type VSCSdkContextType = {
  viverseShareComponent: ViverseShareComponent | null;
  isMountedHeader: boolean;
  isMountedFooter: boolean;
  setIsMountedHeader: (mounted: boolean) => void;
  setIsMountedFooter: (mounted: boolean) => void;
  changeLocale: (locale: Locale) => Promise<void>;
};
const VSCSdkContext = createContext<VSCSdkContextType | null>(null);
export const VSCSdkProvider = t0 => {
  const $ = _c(13);
  const {
    children
  } = t0;
  const router = useRouter();
  const params = useParams();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    setIsRouteLoading
  } = useRouteChangeContext();
  const [isMountedHeader, setIsMountedHeader] = useState(false);
  const [isMountedFooter, setIsMountedFooter] = useState(false);
  let t1;
  if ($[0] !== params || $[1] !== pathname || $[2] !== router || $[3] !== searchParams || $[4] !== setIsRouteLoading) {
    t1 = async locale => {
      setIsRouteLoading(true);
      await setUserLocale(locale);
      const query = Object.fromEntries(searchParams);
      startTransition(() => {
        router.replace({
          pathname,
          params,
          query
        }, {
          locale
        });
      });
    };
    $[0] = params;
    $[1] = pathname;
    $[2] = router;
    $[3] = searchParams;
    $[4] = setIsRouteLoading;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const changeLocale = t1;
  let t2;
  if ($[6] !== changeLocale || $[7] !== isMountedFooter || $[8] !== isMountedHeader) {
    t2 = {
      viverseShareComponent: null,
      isMountedHeader,
      setIsMountedHeader,
      changeLocale,
      isMountedFooter,
      setIsMountedFooter
    };
    $[6] = changeLocale;
    $[7] = isMountedFooter;
    $[8] = isMountedHeader;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== t2) {
    t3 = <VSCSdkContext.Provider value={t2}>{children}</VSCSdkContext.Provider>;
    $[10] = children;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export const useVSCSdkContext = () => {
  const value = useContext(VSCSdkContext);
  if (value == null) {
    throw new Error("useVSCSdkContext cannot be used outside of VSCSdkProvider");
  }
  return value;
};